/* content.tsx generated by @compiled/babel-plugin v3.0.1 */
import "./content.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
var styles = {
  text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
  icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
  common: "_v564g17y",
  fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */
var Content = function Content(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    isLoading = _ref.isLoading;
  return /*#__PURE__*/React.createElement("span", {
    className: ax([styles.common, type === 'text' && styles.text, type === 'icon' && styles.icon, isLoading && styles.fade])
  }, children);
};
export default Content;